
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {QrcodeCapture, QrcodeStream} from "vue-qrcode-reader";
import { Getter } from "vuex-class";

@Component({
    components: {
        QrcodeStream,
        QrcodeCapture,
    },
})

export default class QrCodeStreamerRenderer extends Vue {

    @Prop({default: true})
    public hasForceInput: boolean;

    @Prop({default: false})
    public loading: boolean;

    @Prop({default: true})
    public displayReloadButton: boolean;

    @Getter private isMobile: boolean;

    private mountingReader: boolean = true;
    private qrCodeString: string = null;
    private readerError: any = null;
    private displayScanner: boolean = true;
    private camera: string = "auto";
    private enablingCamera: boolean = false;

    get error() {
        if (this.readerError) {
            return this.$i18n?.t(`alerts.error.${this.readerError}`);
        }
        return null;
    }

    @Watch("loading")
    public handlerLoading(newVal, oldVal) {
        // If we're not loading anymore, put the camera back on
        if (!newVal && oldVal) {
          this.enablingCamera = true;
          this.camera = "auto";
          // The camera takes some time to be enabled,
          // so we need to delay the loading for more smoothness
          setTimeout(() => {
            this.enablingCamera = false;
          }, 550);
        }
    }

    private async onInit(promise): Promise<void> {
        this.qrCodeString = "";
        this.mountingReader = true;
        try {
            await promise;
        } catch (error) {
            this.readerError = error.name;
        } finally {
            this.mountingReader = false;
        }
        if (this.hasForceInput && !this.isMobile && this.$refs.fromUsbScanner) {
            (this.$refs.fromUsbScanner as HTMLFormElement).focus();
        }
    }

    private decodeStream(decodedString: string): void {
        if (decodedString) {
            this.camera = "off";
            this.$emit("decode", decodedString);
        }
    }

    private forceReadQR(): void {
        if (this.qrCodeString) {
            this.displayScanner = false;
            this.qrCodeString = this.qrCodeString.replace(/§/g, "-");
            this.$emit("decode", this.qrCodeString);
        }
    }

    private enterKeyPress(e: KeyboardEvent): void {
        if (e.keyCode === 13) {
            this.forceReadQR();
        }
    }

    private reloadScanner(): void {
        this.displayScanner = false;
        this.camera = "auto";
        setTimeout(() => this.displayScanner = true, 500);
    }
}
